import React from "react";
import { FormattedMessage } from "react-intl";
import cx from 'classnames';
import withStyles from "isomorphic-style-loader/withStyles";
import Link from "../../Link/Link";
import cs from '../../../components/commonStyle.css';
import s from "./AdminDashboard.css";
import { NextIconSvg } from "../../Common/Assets/SvgIconComponent/CommonSvgIcon";
import messages from '../../../locale/jsonMessages';
import CurrencyConverter from "../../CurrencyConverter/CurrencyConverter";

const dashboardRows = [
    {
        label: messages.last30daysUsers,
        valueKey: 'last30DaysCount'
    },
    {
        label: messages.last7Days,
        valueKey: 'last7DaysCount'
    },
    {
        label: messages.last24hoursListings,
        valueKey: 'last24HoursCount'
    }
];

const DashboardCard = ({
    title,
    last24HoursCount,
    last30DaysCount,
    total,
    displayTotal,
    last7DaysCount,
    icon,
    management,
    type,
    customCount,
    isCustom,
    dates,
    iconColor,
    iconBgColor,
    privilegeId,
    validPrivilege,
    isAdminUser,
    isEarnings,
    currency,
    isAverageBooking,
    isCancellationRate
}) => {
    const Icon = icon;
    const isSimpleCard = isAverageBooking || isCancellationRate;
    const showManagementLink = isAdminUser || validPrivilege?.includes(privilegeId);
    const totalFilter = displayTotal !== undefined ? displayTotal : total;
    const rowValues = {
        last24HoursCount,
        last7DaysCount,
        last30DaysCount
    };

    const renderAmount = (amount) => (
        isEarnings || isAverageBooking
            ? <CurrencyConverter amount={amount} currency={currency} isDashboard={true} />
            : amount
    );

    const cardTotal = isCancellationRate
        ? total > 0 ? (`${Number(total || 0).toFixed(2)}%`) : `${0}%`
        : renderAmount(isAverageBooking ? total : totalFilter);

    const simpleDescription = isAverageBooking
        ? messages.averageAmountPerBooking
        : messages.percentageCancellation;

    return (
        <div className={s.dashboardCard} style={{ '--icon-color': iconColor, '--icon-background': iconBgColor }}>
            <div className={s.dashboardCardHeaderWrapper}>
                <div className={cx(s.dashboardCardHeaderTitleFlex, cs.spaceBottom1)}>
                    <span className={cx(cs.commonContentText, cs.greyText, cs.fontWeightMedium)}>{title}</span>
                    <div className={s.dashboardCardIconWrapper}>
                        <Icon />
                    </div>
                </div>
                <div className={cx(s.dashboardCardTotal, cs.commonTitleText, cs.fontWeightBold)}>{cardTotal}</div>
            </div>

            {!isSimpleCard && (
                <div className={s.dashboardEaringsReportWrapper}>
                    {dashboardRows.map(({ label, valueKey }) => (
                        <div key={valueKey} className={s.dashboardCardRow}>
                            <span><FormattedMessage {...label} /></span>
                            <span>{renderAmount(rowValues[valueKey])}</span>
                        </div>
                    ))}
                    {isCustom && (
                        <div className={s.dashboardCardRow}>
                            <span>{dates}</span>
                            <span>{renderAmount(customCount)}</span>
                        </div>
                    )}
                    {showManagementLink && type && (
                        <div className={cx(s.dashboardCardLinkContainer, cs.spaceTop3)}>
                            <Link to={`/siteadmin/${type}/`} className={s.dashboardCardLink} >
                                <span>{management}</span><NextIconSvg className={'imageRotate'} />
                            </Link>
                        </div>
                    )}
                </div>
            )}

            {isSimpleCard && (
                <div className={cx(s.dashboardEaringsReportWrapper, s.simpleCardWrapper)}>
                    <span><FormattedMessage  {...simpleDescription} /></span>
                </div>
            )}
        </div>
    );
};

export default withStyles(cs, s)(DashboardCard);
